export default __webpack_public_path__ + "static/the_energy_of_joy_1-8a28a21507bb256c834475bafca0eeb9.png";